import { ReactComponent as LoadingIcon } from 'icons/loading-icon.svg';

const Icons = {
    LoadingIcon,
};

export default Icons;
